module.exports = __webpack_public_path__ + "img/tddg-4.178fdb3c.jpg";